import { SettingsCustoms } from "./SettingsCustoms"
import { SettingsGrowers } from "./SettingsGrowers"
import { SettingsSuppliers } from "./SettingsSuppliers"
import { SettingsTabs } from "./SettingsTabs"

export const SettingsPage = () => {
    return (
        <div className="reports content">
            <main className="container">
                <h2 className="main-title tw-mb-2 md:tw-mb-4">Settings</h2>
                <SettingsTabs
                    sections={[
                        {
                            id: "suppliers",
                            label: "Suppliers",
                            content: <SettingsSuppliers/>
                        },
                        {
                            id: "growers",
                            label: "Growers",
                            content: <SettingsGrowers/>
                        },
                        {
                            id: "custom-fields",
                            label: "Custom Fields",
                            content: <SettingsCustoms />
                        },
                        // {
                        //     id: "notifications",
                        //     label: "Notifications",
                        //     content: <NotificationsSettings />
                        // }
                    ]}
                />
            </main>

        </div>
    )
}
